import { DictionaryEntity, DossierSearchCriteria, DossierSearchType, Filter, Label } from '@app/pcs/models';
import { AdvancedSearchRequiredFields } from '@app/pcs/reducer/advanced-search/required-fields';
import { Action } from '@ngrx/store';

export enum AdvancedSearchActionTypes {
  InitAdvancedSearchForm = '[AdvancedSearch] Init Advanced Search Form',

  ToggleAdditionalField = '[AdvancedSearch] Toggle Additional Field',
  SetVisibilityOfAdditionalFields = '[AdvancedSearch] Set Visibility Of Additional Fields',

  FetchLabelsForUser = '[AdvancedSearch] Fetch Labels For User',
  FetchLabelsForUserSuccess = '[AdvancedSearch] Fetch Labels For User Success',
  FetchLabelsForUserFail = '[AdvancedSearch] Fetch Labels For User Fail',

  ResetForm = '[AdvancedSearch] Reset Form',
  ResetField = '[AdvancedSearch] Reset Field',
  ResetAllAdditionalFields = '[AdvancedSearch] Reset All Additional Fields',

  AddNewInvolvedAgencyTrafficLightPair = '[AdvancedSearch] Add New Involved Agency Traffic Light Pair',
  RemoveInvolvedAgencyTrafficLightPair = '[AdvancedSearch] Remove Involved Agency Traffic Light Pair',

  AddRequiredFields = '[AdvancedSearch] Add Required Fields',
  RemoveAdditionalFields = '[AdvancedSearch] Remove Additional Fields',

  SearchDossiers = '[AdvancedSearch] Search Dossiers',
  SearchDossiersFail = '[AdvancedSearch] Search Dossiers Fail',

  UpdateProcessTypes = '[AdvancedSearch] Update Process Types',
  UpdateDossierStatuses = '[AdvancedSearch] Update Dossier Statuses',
  UpdateTransitions = '[AdvancedSearch] Update transitions',

  SetFilter = '[AdvancedSearch] Set Filter',

  ResetState = '[AdvancedSearch] Reset State',

  FetchDossierStatuses = '[AdvancedSearch] Fetch Dossier Statuses',
  FetchDossierStatusesSuccess = '[AdvancedSearch] Fetch Dossier Statuses Success',
  FetchDossierStatusesFail = '[AdvancedSearch] Fetch Dossier Statuses Fail',

  CheckBulkEditingProgress = '[AdvancedSearch] Check Bulk Editing Progress ',
  CheckBulkEditingProgressSuccess = '[AdvancedSearch] Check Bulk Editing Progress Success',
  CheckBulkEditingProgressFail = '[AdvancedSearch] Check Bulk Editing Progress Fail',

  FetchAgencyInvolvementOptions = '[AdvancedSearch] Fetch Agency Involvement',
  FetchAgencyInvolvementOptionsSuccess = '[AdvancedSearch] Fetch Agency Involvement Success',
  FetchAgencyInvolvementOptionsFail = '[AdvancedSearch] Fetch Agency Involvement Fail',

  UpdateSearchedPermanentAcceptance = '[AdvancedSearch] Update Searched Permanent Acceptance'
}

export class InitAdvancedSearchForm implements Action {
  readonly type = AdvancedSearchActionTypes.InitAdvancedSearchForm;

  constructor(public payload: { searchCriteria: DossierSearchCriteria; searchType: DossierSearchType }) {
  }
}

export class ToggleAdditionalField implements Action {
  readonly type = AdvancedSearchActionTypes.ToggleAdditionalField;

  constructor(public payload: string) {
  }
}

export class SetVisibilityOfAdditionalFields implements Action {
  readonly type = AdvancedSearchActionTypes.SetVisibilityOfAdditionalFields;

  constructor(public payload: boolean) {
  }
}

export class FetchLabelsForUser implements Action {
  readonly type = AdvancedSearchActionTypes.FetchLabelsForUser;
}

export class FetchLabelsForUserSuccess implements Action {
  readonly type = AdvancedSearchActionTypes.FetchLabelsForUserSuccess;

  constructor(public payload: Label[]) {
  }
}

export class FetchLabelsForUserFail implements Action {
  readonly type = AdvancedSearchActionTypes.FetchLabelsForUserFail;

  constructor(public payload: Error) {
  }
}

export class ResetForm implements Action {
  readonly type = AdvancedSearchActionTypes.ResetForm;

  constructor(public payload: DossierSearchCriteria) {
  }
}

export class ResetField implements Action {
  readonly type = AdvancedSearchActionTypes.ResetField;

  constructor(public payload: string) {
  }
}

export class ResetAllAdditionalFields implements Action {
  readonly type = AdvancedSearchActionTypes.ResetAllAdditionalFields;

  constructor(public payload: DossierSearchType) {
  }
}

export class AddNewInvolvedAgencyTrafficLightPair implements Action {
  readonly type = AdvancedSearchActionTypes.AddNewInvolvedAgencyTrafficLightPair;
}

export class RemoveInvolvedAgencyTrafficLightPair implements Action {
  readonly type = AdvancedSearchActionTypes.RemoveInvolvedAgencyTrafficLightPair;

  constructor(public payload: number) {
  }
}

export class AddRequiredFields implements Action {
  readonly type = AdvancedSearchActionTypes.AddRequiredFields;

  constructor(public payload: AdvancedSearchRequiredFields) {
  }
}

export class RemoveAdditionalFields implements Action {
  readonly type = AdvancedSearchActionTypes.RemoveAdditionalFields;

  constructor(public payload: string[]) {
  }
}

export class SearchDossiers implements Action {
  readonly type = AdvancedSearchActionTypes.SearchDossiers;

  constructor(public payload: { searchCriteria: DossierSearchCriteria; dossierSearchType: DossierSearchType }) {
  }
}

export class SearchDossiersFail implements Action {
  readonly type = AdvancedSearchActionTypes.SearchDossiersFail;

  constructor(public payload: Error) {
  }
}

export class UpdateProcessTypes implements Action {
  readonly type = AdvancedSearchActionTypes.UpdateProcessTypes;

  constructor(public payload: DictionaryEntity[]) {
  }
}

export class UpdateDossierStatuses implements Action {
  readonly type = AdvancedSearchActionTypes.UpdateDossierStatuses;

  constructor(public payload: DictionaryEntity[]) {
  }
}

export class UpdateTransitions implements Action {
  readonly type = AdvancedSearchActionTypes.UpdateTransitions;

  constructor(public payload: any[]) {
  }
}

export class SetFilter implements Action {
  readonly type = AdvancedSearchActionTypes.SetFilter;

  constructor(public payload: Filter) {
  }
}

export class ResetState implements Action {
  readonly type = AdvancedSearchActionTypes.ResetState;
}

export class FetchDossierStatuses implements Action {
  readonly type = AdvancedSearchActionTypes.FetchDossierStatuses;

  constructor(public payload: DictionaryEntity) {
  }
}

export class FetchDossierStatusesSuccess implements Action {
  readonly type = AdvancedSearchActionTypes.FetchDossierStatusesSuccess;

  constructor(public payload: DictionaryEntity[]) {
  }
}

export class FetchDossierStatusesFail implements Action {
  readonly type = AdvancedSearchActionTypes.FetchDossierStatusesFail;

  constructor(public payload: Error) {
  }
}

export class CheckBulkEditingProgress implements Action {
  readonly type = AdvancedSearchActionTypes.CheckBulkEditingProgress;

  constructor(public payload: DossierSearchType) {
  }
}

export class CheckBulkEditingProgressSuccess implements Action {
  readonly type = AdvancedSearchActionTypes.CheckBulkEditingProgressSuccess;

  constructor(public payload: {hasOperationInProgress: boolean}) {
  }
}

export class CheckBulkEditingProgressFail implements Action {
  readonly type = AdvancedSearchActionTypes.CheckBulkEditingProgressFail;

  constructor(public payload: Error) {
  }
}

export class FetchAgencyInvolvementOptions implements Action {
  readonly type = AdvancedSearchActionTypes.FetchAgencyInvolvementOptions;
}


export class FetchAgencyInvolvementOptionsSuccess implements Action {
  readonly type = AdvancedSearchActionTypes.FetchAgencyInvolvementOptionsSuccess;

  constructor(public payload: DictionaryEntity[]) {
  }
}

export class FetchAgencyInvolvementOptionsFail implements Action {
  readonly type = AdvancedSearchActionTypes.FetchAgencyInvolvementOptionsFail;

  constructor(public payload: Error) {
  }
}

export class UpdateSearchedPermanentAcceptance implements Action {
  readonly type = AdvancedSearchActionTypes.UpdateSearchedPermanentAcceptance;

  constructor(public payload: boolean) {
  }
}

export type AdvancedSearchActions =
  | InitAdvancedSearchForm
  | ToggleAdditionalField
  | SetVisibilityOfAdditionalFields
  | FetchLabelsForUser
  | FetchLabelsForUserSuccess
  | FetchLabelsForUserFail
  | UpdateTransitions
  | ResetForm
  | ResetField
  | ResetAllAdditionalFields
  | AddNewInvolvedAgencyTrafficLightPair
  | AddRequiredFields
  | RemoveAdditionalFields
  | RemoveInvolvedAgencyTrafficLightPair
  | SearchDossiers
  | SearchDossiersFail
  | UpdateProcessTypes
  | UpdateDossierStatuses
  | SetFilter
  | ResetState
  | FetchDossierStatuses
  | FetchDossierStatusesFail
  | CheckBulkEditingProgress
  | CheckBulkEditingProgressSuccess
  | CheckBulkEditingProgressFail
  | FetchAgencyInvolvementOptions
  | FetchAgencyInvolvementOptionsSuccess
  | FetchAgencyInvolvementOptionsFail
  | UpdateSearchedPermanentAcceptance;
